import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from '@fs/zion-router'
import { useFeatureFlags } from '@fs/zion-flags'

export default function useSubHeaderItems({ showAdminContent }) {
  const [t] = useTranslation()
  const location = useLocation()
  const {
    memories_dev: { isOn: showDevFeaturesFlag },
    memories_semanticSearchPOC: { isOn: showSemanticSearchPage },
    memories_eol_remove_peopleAndFind: { isOn: hidePeopleAndFind },
    memories_feed_migration: { isOn: showFamilyFeed },
  } = useFeatureFlags([
    'memories_dev',
    'memories_semanticSearchPOC',
    'memories_eol_remove_peopleAndFind',
    'memories_feed_migration',
  ])

  const allItems = useMemo(
    () => ({
      overview: {
        id: 'overview',
        text: t('memories.subnav.overview', 'Overview'),
        url: '/memories',
        active: location.pathname === '/',
      },
      gallery: {
        id: 'gallery',
        text: t('memories.subnav.gallery', 'Gallery'),
        url: '/memories/gallery',
        active: location.pathname === '/gallery' || location.pathname.startsWith('/gallery/'),
      },
      feed: {
        id: 'feed',
        text: t('memories.subnav.feed', 'Family Feed'),
        url: '/memories/feed',
        active: location.pathname.startsWith('/feed'),
      },
      find: {
        id: 'find',
        text: t('memories.subnav.find', 'Find'),
        url: '/memories/find',
        active: location.pathname.startsWith('/find'),
      },
      people: {
        id: 'people',
        text: t('memories.subnav.people', 'People'),
        url: '/memories/people',
        active: location.pathname.startsWith('/people'),
      },
      tree: {
        id: 'tree',
        text: 'Tree',
        url: '/memories/tree',
        active: location.pathname.startsWith('/tree'),
      },
      restore: {
        id: 'restore',
        text: 'Restore',
        url: '/memories/restore',
        active: location.pathname.startsWith('/restore'),
      },
      semanticSearch: {
        id: 'semantic-search',
        text: 'Semantic Search',
        url: '/memories/semantic-search',
        active: location.pathname.startsWith('/semantic-search'),
      },
      admin: {
        id: 'admin',
        text: 'Admin',
        url: '/memories/admin',
        active: location.pathname.startsWith('/admin'),
      },
    }),
    [location.pathname, t]
  )

  const subHeaderItems = useMemo(() => {
    const itemsArray = [allItems.overview, allItems.gallery]

    if (showFamilyFeed) itemsArray.push(allItems.feed)
    if (!hidePeopleAndFind) itemsArray.push(allItems.find, allItems.people)
    if (showDevFeaturesFlag) itemsArray.push(allItems.tree, allItems.restore)
    if (showSemanticSearchPage) itemsArray.push(allItems.semanticSearch)
    if (showDevFeaturesFlag && showAdminContent) itemsArray.push(allItems.admin)

    return itemsArray
  }, [allItems, hidePeopleAndFind, showAdminContent, showDevFeaturesFlag, showFamilyFeed, showSemanticSearchPage])

  return subHeaderItems
}
